import { ref } from "vue";

export const openModalNotification = ref<boolean>(false);

export const changeModal = (arg: boolean) => {
	openModalNotification.value = arg;
};
